import React, { useEffect, useState } from 'react'
import { IncidentOrDeviationApi } from '../../../service/deviation';
import { areaService } from '../../../service/areaServices';
import HeaderSection from '../../common/headerSection';
import PageHeader from '../../common/pageHeader';
import CustomTable from '../../../widgets/table';
import Pagination from '../../../widgets/pagination';
import { useTranslation } from 'react-i18next';
import baseUrl from '../../../service';
import {userService as userRoleServive} from '../../../service/userService';
import { equipments } from '../../../service/equipments';
import { reportServices } from '../../../service/reportServices';
import { DEFAULT_PAGE_SIZE } from '../../../constants/constants';
import AlertModal from '../../../widgets/alertModal';
import CustomToast from '../../../widgets/toaster';

interface TableColumn {
    Header: string;
    accessor: string;
}

export const columns: TableColumn[] = [
  {
    Header: 'Sl.No',
    accessor: 'slno',
  },
    {
        Header: "Deviation Id",
        accessor: "ID",
      },
      {
        Header: "Area Code ",
        accessor: "area_code",
      },
      {
        Header: "Location / Equipment Name",
        accessor: "equipment_name",
      },
      {
        Header: "Activity / Process ",
        accessor: "process",
      },
      {
        Header: "Operator Name",
        accessor: "operator_name",
      },
      {
        Header: "Operator ID",
        accessor: "operator_id",
      },
      {
        Header: "Date",
        accessor: "date",
      },
      {
        Header: "Reason ",
        accessor: "reason",
      },
      {
        Header: "exceptionHandling.tableColumns.status",
        accessor: "status",
      },
     
  ]

  interface ActiveAirSamplingReportProps {
    ishide?: boolean;
  }
  
  
  const DeviationReport: React.FC<ActiveAirSamplingReportProps> = ({ ishide }) => {   

    const { t } = useTranslation()
    const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
    const [page, setPage] = useState(1)
    const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE)
    const [totalPages, setTotalPages] = useState(0)
    const [totalElements, setTotalElements] = useState(0)
    const [sort, setSort] = useState("id");
    const [order, setOrder] = useState("desc");
    const [reasonId, setReasonId] = useState("");
    const [locationType, setLocationType] = useState("");
    const [keyWord, setkeyWord] = useState("")
    const [useEffectRequired, setUseEffectRequired] = useState(false);
    const [authUserID, setAuthUserID] = useState("");
    const [showDownloadCSV, setShowDownloadCSV] = useState(true);
    const [isApplyClicked, setIsApplyClicked] = useState(true);
    const [addFilterData, setAddFilterData] = useState({
        area: "",     
        equipment : "",
        operator:"",
        fromDate: "",
        toDate: "",
      });
    const [areas, setAreas] = useState<Array<any>>([]);
    const [userData , setUserData] = useState<Array<any>>([]); 
    const [equipmentList, setEquipmentList] = useState<Array<any>>([]); 
    const [pdfDownload, setpdfDownload] = useState(false);
    const [toDateConstraints, setToDateConstraints] = useState({
      min: "",
      max: "",
    });
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("");
    const [isToDateEnabled, setIsToDateEnabled] = useState(false);

//api call to list exception plate detail in request tab 
const getExceptionPlates = async () => {
  setPlateDetails([
      {loading: true},
    ]);
try {
    const response = await reportServices.deviationReport(page, pageSize, addFilterData.fromDate, addFilterData.toDate, addFilterData.equipment, addFilterData.operator, addFilterData.area,sort,order);
    if(response.status && response.statusCode === 200){
    try {
        if ( Array.isArray(response.data) && response.data?.length > 0) {
            setTotalPages(response?.totalPages)
            setTotalElements(response?.totalElements)
            let rowData: any = response.data.map((element: any, index: number) => {

            const statusNumber = parseInt(element.location_type, 10); 
            const area_type = areaService.getLocationStatus(statusNumber);
            return { 
                ID: "V" + element.id, 
                slno: index + 1,
                area_code: element.area_code,
                equipment_name: element.area_name,
                process: element.activity,
                
                operator_name : element.operator_name,
                operator_id : element.operator_id,
                date : element.date,
                reason: element.reason,
                status: element.status[0].toUpperCase() + element.status.slice(1),
                id : element.id
            };
            });
            setPlateDetails(rowData);
        }
        } catch (error) {
        console.log(error); 
        }
    } else {
    setPlateDetails([])
    setTotalPages(0)
    setTotalElements(0)
    }
} catch (error) {
    console.error('Plate response', error);
}
};

const handlePageChange = (newPage : any, pageSize?: number) => {
    setPage(newPage);
    if(pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

    useEffect(() => {
        getExceptionPlates();
        setUseEffectRequired(false)
    }, [useEffectRequired])

    const handleApplyClick =() =>{
        setShowDownloadCSV(false);
        setIsApplyClicked(true);
        getExceptionPlates();
        // listAuditTrialReport();
    }

    const handleFilterDataChange = (e : any) => {
        setShowDownloadCSV(true)
        setIsApplyClicked(false)
        const { name, value } = e.target;
        setAddFilterData((prevFormData : any) => ({
            ...prevFormData, 
            [name]: value,
        }));

        if(name === "toDate" && value === "") {
          setToDateConstraints({
            min: "",
            max: "",
          });
          setAddFilterData(prevState => ({
            ...prevState,
            ["fromDate"]: ""
          }));
        }
    };

    const handleCancel = () => {
        const initialFormData = {
        area: "",
        equipment : "",
        operator:"",
        fromDate: "",
        toDate: "",
        };
        setAddFilterData(initialFormData);
        setUseEffectRequired(true)
        setShowDownloadCSV(true);
        // listAuditTrialReport();
        setToDateConstraints({
          min: "",
          max: "",
        })
        setIsToDateEnabled(false);
    }
    
    const downloadAuditCSV = async () => {
        setpdfDownload(false)
        const link = `${baseUrl}/summary/deviation?sort=id&order=desc&area_code=${addFilterData.area}&equipment_id=${addFilterData.equipment}&operator_id=${addFilterData.operator}&from_date_time=${addFilterData.fromDate}&to_date_time=${addFilterData.toDate}&auth_id=${authUserID}`
        window.location.href = link;
        setShowDownloadCSV(true)
        setIsApplyClicked(true)
    };


    const geAreaTypeList = async () => {
      try {  
        const response = await areaService.getParentAreaLists([11,10,13,15,20,21,22]);
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                let rowData: any = response.data.map((element: any, index: number) => {
    
                  return { 
                      slno: index + 1, 
                      policy_id : element.policy_id,
                      id : element.id,
                      title: element.name,
                  };
                });
                setAreas(rowData);
              }
            } catch (error) {
              console.log(error);
            }
        }
      } catch (error) {
        console.error('user response', error);
      }
    }
      // function to get operator api list
    const getOperatorList = async () => {
      try {
        // const userRole = parseInt(addFilterData.role, 10);  
        const response = await userRoleServive.getUserNameList("");
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                let rowData: any = response.data.map((element: any, index: number) => {

                  return { 
                      slno: index + 1, 
                      id: element.id,
                      name: `${element.first_name} ${element.last_name}`,
                  };
                });
                setUserData(rowData);
              }
            } catch (error) {
              console.log(error);
            }
        } else {
          setUserData([]);
        }
      } catch (error) {
        console.error(error);
      }
    };
  
    const listEquipments = async () => {
      try {
        const response = await equipments.listEquipmentFilter("");
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                let rowData: any = response.data.map((element: any, index: number) => {
  
                  return { 
                      slno: index + 1, 
                      id : element.id,
                      name: element.name,
                  };
                });
                setEquipmentList(rowData);
              }
            } catch (error) {
              console.log(error);
            }
        }else{
          setEquipmentList([]);
        }
      } catch (error) {
        console.error('user response', error);
      }
    }
   
    useEffect(() =>{
      var storedData = localStorage.getItem("userDetails");

      if (storedData) {
        var storedObject = JSON.parse(storedData);
        setAuthUserID(storedObject[0].x_userid);
      }

      geAreaTypeList();
      getOperatorList();
      listEquipments();
    },[])

    
    const handleSort = (key: string, value: boolean) => {
      setSort(key)
      if (value) {
        setOrder("asc")
      } else {
        setOrder("desc")
      }
      setUseEffectRequired(true)
    }

    const formatDateTime = (date: string | Date): string => {
      if (!date) return "";
      const d = new Date(date);
      return (
        d.getFullYear() +
        "-" +
        String(d.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(d.getDate()).padStart(2, "0") +
        "T" +
        String(d.getHours()).padStart(2, "0") +
        ":" +
        String(d.getMinutes()).padStart(2, "0")
      );
    };

  return (
    <div>
      <CustomToast
                  show={showToast}
                  onClose={() => setShowToast(false)}
                  delay={5000}
                  message={toastMessage}
                  toastType={toastType}
            />
        {!ishide && (
        <>
       <HeaderSection />
       <PageHeader pageHeader="Deviation / Incident Reporting" />
       </>
      )}
       <div className="d-flex justify-content-around my-4">

        <div className="select-container" style={{display: "flex", flexDirection: "column"}}>
        <label htmlFor="" style={{color: "black", fontSize: "12px"}}>Location</label>
        <select name="area" className='areaTypeSelect' value={addFilterData.area}  onChange={handleFilterDataChange}>
        <option value="">Select</option>
              {areas?.map((obj, index) => (
                <option key={index} value={obj?.id}>
                  {obj?.title}
                </option>
              ))}
        </select>
        </div>


        <div className="select-container" style={{display: "flex", flexDirection: "column"}}>
        <label htmlFor="" style={{color: "black", fontSize: "12px"}}>Equipment</label>
        <select className='areaTypeSelect' name="equipment" value={addFilterData.equipment}  onChange={handleFilterDataChange} >
            <option value="">Select</option>
            {equipmentList.map((type) => (
            <option key={type.id} value={type.id}>
                {type.name}
            </option>
            ))}
        </select>
        </div>

        <div className="select-container" style={{display: "flex", flexDirection: "column"}}>
        <label htmlFor="" style={{color: "black", fontSize: "12px"}}>Operator</label>
        <select name="operator" className='areaTypeSelect' value={addFilterData.operator}  onChange={handleFilterDataChange}  >
            <option value="">Select</option>
            {userData.map((type, index) => (
                        <option key={index} value={type?.id}>
                          {type?.name}
                        </option>
            ))}
        </select>
        </div>

        <div className="d-flex" style={{marginRight: "4%"}} >

        <div className="select-container auditTrialReportDate " 
            style={{display: "flex", flexDirection: "column", marginRight:"15%"}}>
            <label htmlFor="" style={{color: "black", fontSize: "12px"}}><span>From Date<span style={{ color: "red" }}>*</span></span></label>
            {/* <label htmlFor="" style={{color: "black", fontSize: "12px"}}>From Date</label> */}
            <input
            id="selectedDate"
            className="form-control"
            name="fromDate"
            type="datetime-local"
            value={formatDateTime(addFilterData.fromDate)}  
            onChange={(e) => {
              handleFilterDataChange(e);
        
              const fromDate = new Date(e.target.value);
              // if (!isNaN(fromDate.getTime())) {
              //   // Calculate the min and max for the toDate field
              //   // const minDate = new Date(fromDate);
              //   // const maxDate = new Date(fromDate);
              //   // maxDate.setDate(maxDate.getDate() + 14);
        
              //   // // Update state with min and max dates
              //   // setToDateConstraints({
              //   //   min: formatDateTime(minDate),
              //   //   max: formatDateTime(maxDate),
              //   // });
              //   setAddFilterData((prevData) => ({
              //     ...prevData,
              //     fromDate: formatDateTime(fromDate),
              //     //toDate: formatDateTime(minDate),
              //     toDate: formatDateTime(fromDate),
              //   }));
              //   setIsToDateEnabled(true);
              // }
              if (!isNaN(fromDate.getTime())) {
                  // Set the minimum allowed date for toDate to be the selected fromDate
                  setToDateConstraints({
                    min: e.target.value,
                    max: ""
                  });

                  setAddFilterData(prevData => ({
                    ...prevData,
                    fromDate: formatDateTime(fromDate),
                    // Reset toDate if it's before the new fromDate
                    ...(prevData.toDate && new Date(prevData.toDate) < fromDate && { toDate: "" })
                  }));
                  
                  setIsToDateEnabled(true);
                }
            }}

            onKeyDown={(e) => {
              const allowedKeys = [
                "Tab",
                "Enter",
                "Escape",
              ];
              if (!allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => e.preventDefault()}
        />
        </div>

        <div className="select-container auditTrialReportDate" 
            style={{display: "flex", flexDirection: "column"}}>
            <label htmlFor="" style={{color: "black", fontSize: "12px"}}><span>To Date<span style={{ color: "red" }}>*</span></span></label>
            {/* <label htmlFor="" style={{color: "black", fontSize: "12px"}}>To Date</label> */}
            <input
            id="selectedDate"
            className="form-control"
            name="toDate"
            type="datetime-local"
            value={formatDateTime(addFilterData.toDate)} 
            min={toDateConstraints.min}
            max={toDateConstraints.max} 
            disabled={!isToDateEnabled}
            onChange={handleFilterDataChange}
            onKeyDown={(e) => {
              const allowedKeys = [
                "Tab",
                "Enter",
                "Escape",
              ];
              if (!allowedKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => e.preventDefault()}
            />
        </div>
        </div>
        </div>

        <div className="mt-3 mx-2 d-flex justify-content-end" >
            <button className="analyticalFilterClose" title="Click here to Reset Filter"  onClick={handleCancel}>{t("buttons.cancel")}</button>
            <button 
            className={isApplyClicked ? "analyticalFilterApplyDisabledDownload" : "analyticalFilterApply"}
            disabled={isApplyClicked} 
            onClick={handleApplyClick} 
            title="Click here to Apply Filter" >
                {t("buttons.apply")}
            </button>
            <button 
            className={showDownloadCSV ? "analyticalFilterDisabledDownload" : "analyticalFilterDownload"}
            disabled={showDownloadCSV} 
            onClick={() => {
            if (!addFilterData.fromDate || !addFilterData.toDate) {
              setToastMessage("Select a Date Range to Download PDF Report.");
              setToastType("error");
              setShowToast(true);
            } else {
              setpdfDownload(true);
            }
          }}  
            //onClick={()=>setpdfDownload(true)}
            title="Click here to Download CSV" >
            {t("buttons.download_pdf")}
            </button>

        </div>



       <div className=" mx-3 pe-2" style={{"height":"45vh"}}>
        <CustomTable
        data={plateDetails}
        columns={columns}
        isEditable={false}
        totalElements={totalElements}
        isActionVisible={false}
        isViewVisible={false}
        isSeachable={false}
        tableHead={'Incident / Deviation'}
        showBatchFilter={false}
        showLotCodeFilter={false}
        onSortClick={handleSort}
      />
    </div>
    <div>
      <Pagination
        page={page}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
      />
    </div>

    <AlertModal
        show={pdfDownload}
        onHide={() => setpdfDownload(false)}
        title="Alert"
        message={t('downloadPdf.download')}
        onConfirm={downloadAuditCSV}
      />
    </div>
  )
}

export default DeviationReport
